// Swedish translations
export const sv: Record<string, string> = {
  'menu.dashboard': 'Instrumentpanel',
  'menu.orderNew': 'Produktregistrering',
  'menu.deliveryList': 'Leveranslista',
  'menu.delivery': 'Leverans',
  'menu.receipt': 'Skriv ut kvitto/etikett',
  'menu.definitions': 'Definitioner',
  'menu.customers': 'Kunder',
  'menu.products': 'Produktdefinitioner',
  'menu.pricing': 'Prisdefinitioner',
  'menu.tailoring': 'Skräddaroperationer',
  'menu.attributes': 'Produktattribut',
  'menu.users': 'Användare',
  'menu.productOrdering': 'Produktordning',
  'menu.discounts': 'Rabattdefinitioner',
  'menu.settings': 'Inställningar',
  'menu.generalSettings': 'Allmänna inställningar',
  'menu.permissions': 'Behörighetshantering',
  'menu.subscription': 'Prenumeration',
  'menu.invoices': 'Fakturahantering',
  'menu.expenses': 'Utgiftsinmatning',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Rapporter & bokföring',
  'menu.systemAndCommunication': 'System & kommunikation',
  'menu.reportsList': 'Kvittolista',
  'menu.accountStatement': 'Kontoutdrag',
  'menu.tickets': 'Supportförfrågningar',
  'menu.support': 'Support',
  'menu.profile': 'Profil',
  'menu.logout': 'Logga ut',
  'menu.notifications': 'SMS/WhatsApp-aviseringar',
  'menu.whatsappConnection': 'WhatsApp-anslutning',
  'menu.smsConnection': 'SMS-anslutning',
  'dashboard.title': 'Instrumentpanel',
  'dashboard.todaySales': 'Dagens försäljning',
  'dashboard.totalOrders': 'Totala beställningar',
  'dashboard.pendingDeliveries': 'Väntande leveranser',
  'dashboard.activeCustomers': 'Aktiva kunder',
  'dashboard.recentOrders': 'Senaste beställningar',
  'dashboard.viewAll': 'Visa alla',
  'dashboard.quickActions': 'Snabbåtgärder',
  'dashboard.newOrder': 'Ny beställning',
  'dashboard.newCustomer': 'Ny kund',
  'dashboard.deliveries': 'Leveranser',
  'dashboard.reports': 'Rapporter',
  'dashboard.today': 'Idag',
  'dashboard.yesterday': 'Igår',
  'dashboard.week': 'Vecka',
  'dashboard.month': 'Månad',
  'dashboard.quarter': 'Kvartal',
  'dashboard.year': 'År',
  'dashboard.totalRevenue': 'Total intäkt',
  'dashboard.totalOrdersCard': 'Totala beställningar',
  'dashboard.totalPieces': 'Totala artiklar',
  'dashboard.cancelled': 'Avbruten',
  'dashboard.inProcess': 'Pågående',
  'dashboard.inProcessDesc': 'Beställningar pågående',
  'dashboard.ready': 'Klar',
  'dashboard.readyDesc': 'Beställningar klara för leverans',
  'dashboard.delivered': 'Levererad',
  'dashboard.deliveredDesc': 'Slutförda beställningar',
  'dashboard.announcements': 'Meddelanden',
  'dashboard.announcementAll': 'Allmänt',
  'dashboard.announcementPrivate': 'Privat',
  'order.title': 'Ny beställning',
  'order.customer': 'Kund',
  'order.selectCustomer': 'Välj kund',
  'order.newCustomer': 'Ny kund',
  'order.products': 'Produkter',
  'order.addProduct': 'Lägg till produkt',
  'order.selectProduct': 'Välj produkt',
  'order.quantity': 'Antal',
  'order.price': 'Pris',
  'order.total': 'Totalt',
  'order.discount': 'Rabatt',
  'order.subtotal': 'Delsumma',
  'order.tax': 'Moms',
  'order.grandTotal': 'Totalsumma',
  'order.payment': 'Betalning',
  'order.paymentMethod': 'Betalningsmetod',
  'order.cash': 'Kontanter',
  'order.card': 'Kreditkort',
  'order.credit': 'Kredit',
  'order.amountPaid': 'Betalt belopp',
  'order.remainingBalance': 'Återstående saldo',
  'order.deliveryDate': 'Leveransdatum',
  'order.notes': 'Anteckningar',
  'order.createOrder': 'Skapa beställning',
  'order.cancel': 'Avbryt',
  'users.title': 'Användare',
  'users.addNew': 'Ny användare',
  'users.name': 'Namn',
  'users.email': 'E-post',
  'users.role': 'Roll',
  'users.pin': 'PIN',
  'users.permissions': 'Behörigheter',
  'users.allPermissions': 'Alla behörigheter',
  'users.permissionCount': '{count} behörigheter',
  'users.changePin': 'Ändra PIN',
  'users.edit': 'Redigera',
  'users.delete': 'Ta bort',
  'users.newUser': 'Ny användare',
  'users.editUser': 'Redigera användare',
  'users.editingUser': 'Redigerar {name}',
  'users.deleteUserTitle': 'Ta bort användare',
  'users.deletingUser': 'Är du säker på att du vill ta bort {name}?',
  'users.pinCode': 'PIN-kod (4-6 siffror)',
  'users.selectRole': 'Välj roll',
  'users.patron': 'Ägare',
  'users.kasiyer': 'Kassör',
  'users.sofor': 'Chaufför',
  'users.eleman': 'Anställd',
  'users.changePinTitle': 'Ändra PIN-kod',
  'users.newPin': 'Ny PIN-kod',
  'users.confirmPin': 'Bekräfta PIN-kod',
  'users.pinMismatch': 'PIN-koderna matchar inte',
  'users.pinRequired': 'PIN-kod krävs',
  'users.pinLength': 'PIN-koden måste vara 4-6 siffror',
  'users.changingPinFor': 'Ändrar PIN för {name}',
  'products.title': 'Produktdefinitioner',
  'products.addNew': 'Ny produkt',
  'products.category': 'Kategori',
  'products.name': 'Produktnamn',
  'products.price': 'Pris',
  'products.color': 'Färg',
  'products.active': 'Aktiv',
  'products.actions': 'Åtgärder',
  'products.search': 'Sök produkt...',
  'products.noProducts': 'Inga produkter hittades',
  'products.noCategoryProducts': 'Inga produkter i denna kategori',
  'products.emptyCart': 'Varukorgen är tom',
  'service.tailor': 'Skräddare',
  'service.dryCleaning': 'Kemtvätt',
  'service.washing': 'Tvätt',
  'service.ironing': 'Strykning',
  'service.shoeShine': 'Skoputsning',
  'service.carpet': 'Matta',
  'service.tailoring': 'Skrädderiändringar',
  'service.carpetWashing': 'Matttvätt',
  'service.selectService': 'Välj tjänst',
  'service.addToCart': 'Lägg till i kundvagn',
  'service.total': 'Totalt',
  'common.yes': 'Ja',
  'common.no': 'Nej',
  'common.cancel': 'Avbryt',
  'common.confirm': 'Bekräfta',
  'common.delete': 'Ta bort',
  'common.edit': 'Redigera',
  'common.save': 'Spara',
  'common.search': 'Sök',
  'common.loading': 'Laddar...',
  'common.noData': 'Ingen data',
  'common.actions': 'Åtgärder',
  'common.status': 'Status',
  'common.date': 'Datum',
  'common.time': 'Tid',
  'common.total': 'Totalt',
  'common.filter': 'Filtrera',
  'common.export': 'Exportera',
  'common.print': 'Skriv ut',
  'common.close': 'Stäng',
  'common.back': 'Tillbaka',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'Skicka',
  'common.reset': 'Återställ',
  'common.create': 'Skapa',
  'common.creating': 'Skapar...',
  'common.later': 'Senare',
  'common.clear': 'Rensa',
  'common.copied': 'Kopierad!',
  'common.copyError': 'Kopiering misslyckades',
  'common.autoDetected': 'Automatisk identifierad',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.subtitle': 'Kemtvätt Hanteringssystem',
  'login.tenantId': 'Företags-ID',
  'login.tenantPlaceholder': 'företag-id (t.ex: acme-clean)',
  'login.tenantIdHelp': 'Ange din unika företagsidentifierare',
  'login.continue': 'Fortsätt →',
  'login.notMember': 'Inte medlem än?',
  'login.startTrial': 'Starta gratis provperiod',
  'login.adminLogin': '🔒 Administratörsinloggning',
  'login.enterPin': 'Ange din PIN-kod',
  'login.changeTenant': 'Byt företag',
  'login.clear': 'Rensa',
  'login.delete': 'Ta bort',
  'login.login': 'Logga in',
  'login.loggingIn': 'Loggar in...',
  'login.defaultPinOwner': 'Standard PIN: <strong>1234</strong> (Ägare)',
  'login.defaultPinCashier': 'Standard PIN: <strong>0000</strong> (Kassör)',
  'login.systemInitializing': 'Initierar system...',
  'login.pinMinLength': 'PIN måste vara minst 4 siffror',
  'login.invalidTenantId': 'Ange ett giltigt företags-ID',
  'login.tenantNotFound': 'Denna företagskod hittades inte. Kontrollera eller skapa ett nytt konto.',
  'login.loginFailed': 'Inloggning misslyckades',
  'login.welcome': 'Välkommen, {name}',
  'login.tagline': 'Kemtvättsprogram — Smarta och enkla lösningar för din verksamhet',
  'signup.title': 'Starta gratis provperiod',
  'signup.subtitle': '15 dagar gratis, inget kreditkort krävs',
  'signup.backToLogin': 'Tillbaka till inloggningssidan',
  'signup.companyCode': 'Företagskod',
  'signup.companyCodePlaceholder': 't.ex: cleanpro',
  'signup.companyCodeHelp': 'Denna kod kommer att användas för att logga in i systemet',
  'signup.companyCodeMinLength': 'Företagskoden måste vara minst 3 tecken',
  'signup.companyName': 'Företagsnamn',
  'signup.companyNamePlaceholder': 'Ditt företagsnamn',
  'signup.companyNameRequired': 'Företagsnamn krävs',
  'signup.fullName': 'Fullständigt namn',
  'signup.fullNamePlaceholder': 'Ditt fullständiga namn',
  'signup.fullNameRequired': 'Fullständigt namn krävs',
  'signup.phone': 'Telefon',
  'signup.phonePlaceholder': '+46 70 123 45 67',
  'signup.validPhoneRequired': 'Ange ett giltigt telefonnummer',
  'signup.email': 'E-post',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'Ange en giltig e-postadress',
  'signup.createAccount': 'Skapa konto',
  'signup.creating': 'Skapar...',
  'signup.terms': 'Genom att skapa ett konto godkänner du användarvillkoren och sekretesspolicyn.',
  'signup.success': 'Registreringen lyckades! Din inloggningsinformation har skickats till din e-post.',
  'signup.successTitle': 'Registrering lyckades!',
  'signup.successMessage': 'Ditt konto har skapats framgångsrikt.',
  'signup.emailSent': 'Din inloggningsinformation har skickats till din e-post.',
  'signup.redirecting': 'Omdirigerar till inloggningssidan...',
  'signup.startupPackageLoaded': 'Startpaket laddad!',
  'signup.products': 'Produkter',
  'signup.customers': 'Kunder',
  'signup.users': 'Användare',
  'signup.demoDataReady': '✨ Din demodata är klar, du kan börja använda den omedelbart!',
  'signup.loginInfo': '📧 Din inloggningsinformation',
  'signup.loginInfoSent': '💡 Denna information har också skickats till din e-post',
  'signup.loginNow': 'Logga in nu →',
  'expenses.expenseType': 'Utgiftstyp',
  'expenses.allBranches': 'Alla filialer',
  'expenses.noBranch': 'Ingen filial',
  'expenses.allTypes': 'Alla typer',
  'expenses.categoryBy': 'Per kategori',
  'expenses.records': 'poster',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Det gick inte att skapa Excel-filen',
  'expenses.branchSelect': 'Välj filial',
  'expenses.noBranchSelected': '— Ingen filial vald —',
  'expenses.myBranch': 'Min filial',
  'expenses.canOnlyDeleteToday': 'Du kan bara ta bort utgifter du angav idag.',
};
